/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LogoService {

    /**
     * @returns string Successfully uploaded a logo
     * @throws ApiError
     */
    public static postUploadLogo({
        locale,
        formData,
    }: {
        /**
         * Locale
         */
        locale?: string | null,
        formData?: {
            file: Blob;
        },
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/logos',
            query: {
                'locale': locale,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad request will be thrown when by validating file type.`,
            },
        });
    }

}
